import apiClient from '@/services/axios'

export const authorizeZalora = ({ access_key, business_id, data }) => {
  return apiClient({
    method: 'post',
    url: 'channel/zalora_id/shop/cmd/auth/authorize',
    headers: {
      'Access-Key': access_key,
      'Business-Id': business_id,
    },
    data,
  })
}

export const disconnectZalora = ({ access_key, business_id, channel_id }) => {
  return apiClient({
    method: 'put',
    url: 'channel/zalora_id/shop/cmd/disconnect',
    headers: {
      'Access-Key': access_key,
      'Business-Id': business_id,
    },
    params: { channel_id },
  })
}

export const getZaloraDetailChannel = ({ business_id, channel_id, signal }) => {
  return apiClient({
    method: 'get',
    url: `/channel/zalora_id/shop/query/${channel_id}`,
    headers: {
      'Business-Id': business_id,
    },
    signal,
  })
}

export const updateZaloraAutoAcceptPerWarehouse = ({ business_id, channel_code, channel_id, data }) => {
  return apiClient({
    method: 'put',
    url: `/channel/${channel_code}/shop/cmd/${channel_id}/warehouse`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const getLatestZaloraProductChannelSyncStatus = ({ business_id, channel_id, shop_id }) => {
  return apiClient({
    method: 'get',
    url: `/channel/zalora_id/product/query/${channel_id}/sync/${shop_id}`,
    headers: {
      'Business-Id': business_id,
    },
    params: { channel_id },
  })
}

export const getZaloraWarehouseChannelList = ({ channel_id, business_id }) => {
  return apiClient({
    method: 'get',
    url: `/channel/zalora_id/shop/query/${channel_id}/warehouse`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const mappingWarehouseZaloraChannel = ({ business_id, data }) => {
  return apiClient({
    method: 'post',
    url: `/channel/zalora_id/shop/cmd/warehouse/map`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const unMappingWarehouseZaloraChannel = ({ business_id, data }) => {
  return apiClient({
    method: 'post',
    url: `/channel/zalora_id/shop/cmd/warehouse/unmap`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}